(function() {
    'use strict';

a3_cabin_reports.directive('groundHeader', groundHeader);
    
    
 /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name groundHeader
   * @restrict E
   * @description
   *   Implementation of groundHeader (appears in groundDuty-info view)
   *    Initialize the template of the header while you are in the Ground Duty Level
   * @example
   *   Usage:
   *   <ground-header></ground-header>
   * @ngInject 
   */ 
       
function groundHeader () {
		return {
			restrict: 'E',
			terminal: true,
			templateUrl: "views/GroundDuty/header.tpl.html",
			scope: false
		}
	} 

})();
